import { StorageKeyEnum as s } from "../../const/StorageKeyEnum.js";
import { http as o } from "../http.js";
import r from "localforage";
import { AUTH_TOKEN_EXPIRE_TIME as c } from "../../const/Auth.js";
const _ = "/api/v1/refresh_token", m = async (e) => {
  const t = await o().post("/api/v1/login", e);
  if (t.code === 0) {
    const a = t.data?.access_token;
    console.log("accessToken: ", a);
    const n = t.data?.refresh_token;
    console.log("refreshToken: ", n);
    const i = Date.now() + c;
    await r.setItem(s.ADMIN_TOKEN, a), await r.setItem(s.ADMIN_REFRESH_TOKEN, n), await r.setItem(s.ADMIN_TOKEN_EXPIRE_TIME, i);
  }
  return t;
}, I = async () => {
  const e = await o().get(_);
  if (e.code === 0) {
    const t = e.data?.access_token, a = Date.now() + c;
    await r.setItem(s.ADMIN_TOKEN, t), await r.setItem(s.ADMIN_TOKEN_EXPIRE_TIME, a);
  }
  return e;
}, f = (e, t) => o().post("/api/v1/set_password", e, {
  Authorization: `Bearer ${t}`
}), d = (e, t) => o().put("/api/v1/set_new_user_password", e, {
  Authorization: `Bearer ${t}`
}), u = (e) => o().put("/api/v1/reset_password", e), N = (e) => o().get("/api/v1/gen_verification_code", { email: e, url: "1" });
export {
  N as genVerificationCode,
  m as login,
  I as refreshAccessToken,
  _ as refreshTokenUrl,
  u as resetPassword,
  d as setNewUserPassword,
  f as setPassword
};
